/**
 * @license
 * @copyright Copyright Motili Inc., 2017 All Rights Reserved
 */

// import './style/contractor-mobile-scheduling.styl';
// import './style/tenant-mobile-scheduling.styl';

module.exports = {
    path: '/m/order/pick-up/:token',
    getComponent(nextState, callback) {
        require.ensure([], (require) => {
            callback(null, require('./PickUpContainer'));
        });
    }
};



// WEBPACK FOOTER //
// ./src/app/components/order/order-pickup/route.OrderPickUp.js